import { IField } from '../types/calculator';

/**
 * Плейсхолдер поля может быть строкой или массивом строк.
 * Эта утилита возвращает конкретную строку или undefined.
 */
export const getFieldPlaceholder = (placeholder: IField['placeholder'], index?: number): string | undefined => {
  if (typeof placeholder === 'string') {
    return placeholder;
  }

  if (Array.isArray(placeholder)) {
    return placeholder[index ?? 0];
  }

  return undefined;
};
